import { render, staticRenderFns } from "./TimewithLable.vue?vue&type=template&id=20a5161c&scoped=true&"
import script from "./TimewithLable.vue?vue&type=script&lang=js&"
export * from "./TimewithLable.vue?vue&type=script&lang=js&"
import style0 from "./TimewithLable.vue?vue&type=style&index=0&id=20a5161c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5161c",
  null
  
)

export default component.exports